import type { PackagingComponent } from '@/shared/hooks/api/packagingSuppliers'
import {
  isEn18120DfrAssessmentEntry,
  isPaperRecyclabilityAssessmentEntry,
  type En18120DfrAssessmentStoredEntry,
  type PackagingRecyclabilityAssessmentStoredEntry,
} from '@/shared/hooks/api/packagingSuppliers'

const BASE_STANDARDS = 'EN 13430:2004; EN 13437:2003'

function hasPaperPackagingMaterial(components: PackagingComponent[]): boolean {
  return components.some(
    (component) => component.material === 'PAPER_CARDBOARD'
  )
}

function hasPaperRecyclabilityHistory(
  history: PackagingRecyclabilityAssessmentStoredEntry[] | undefined
): boolean {
  if (history == null) {
    return false
  }
  return history.some((entry) => isPaperRecyclabilityAssessmentEntry(entry))
}

function findLatestEn18120Entry(
  history: PackagingRecyclabilityAssessmentStoredEntry[] | undefined
): En18120DfrAssessmentStoredEntry | null {
  if (history == null) {
    return null
  }
  for (const entry of history) {
    if (isEn18120DfrAssessmentEntry(entry)) {
      return entry
    }
  }
  return null
}

function normalizeStandardRef(ref: string): string {
  return ref.trim()
}

export function resolveRecyclabilityAssessmentStandardsApplied(params: {
  components: PackagingComponent[]
  history: PackagingRecyclabilityAssessmentStoredEntry[] | undefined
}): string {
  const parts: string[] = [BASE_STANDARDS]

  const en18120Entry = findLatestEn18120Entry(params.history)
  if (en18120Entry != null) {
    const seen = new Set<string>()
    for (const ref of en18120Entry.result.standardRefs) {
      const normalized = normalizeStandardRef(ref)
      if (normalized.length === 0 || seen.has(normalized)) {
        continue
      }
      seen.add(normalized)
      parts.push(normalized)
    }
  }

  if (
    hasPaperPackagingMaterial(params.components) ||
    hasPaperRecyclabilityHistory(params.history)
  ) {
    parts.push('EN 643')
  }

  return parts.join('; ')
}
